<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Street Preview"
      id="admin_delete_street_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn @click="$router.go(-1)" small rounded outlined color="default">
        <v-icon left>mdi-trash-can</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="street.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606031411/botswana%20services/website%20assets/street_ypavnx.jpg'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Street Concent Form "
      id="admin_delete_street_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="street_delete_form_ref"
      id="street_delete_form"
      message="<b>Delete was succesfull</b> <br/> Street has been removed"
      :is_loading="is_loading"
      :seed="{street:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedForm from "../../../components/CardedForm";
import ViewHeader from "../../../components/ViewHeader";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminStreetsDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedForm,
    DeleteConcentForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      street: {
        id: 0,
        name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        },
        city: {
            id: 0,
            name: ""
        },
        ward: {
            id: 0,
            name: ""
        }
      },
      errors: [],
      message: "",
      not_found: false,
      records: null,
      total: 0,
      scan_limit: 0,
    };
  },
  methods: {
    on_success() {
      //go back to wards list
      this.$router.push("/admin/locations/streets/list");
    },
    load_item() {
      this.$emit("on-show-loader");
      ServerClient.Locations.get_street(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("street to be deleted ", res);
          if (res == null) {
            this.not_found = true;
          } else {
            this.street = res;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading street details on admin delete street ",
            errors
          );
        }
      );
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
          {
              text: "Ward",
              val: this.street.ward.name
          },
        {
          text: "City",
          val: this.street.city.name,
        },
        { text: "District:", val: this.street.district.name },
        { text: "Country:", val: this.street.country.name },
      ];
      return facts;
    },
  },
  mounted() {
    var item_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Delete Street",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Streets",
          disabled: false,
          href: "/admin/locations/streets/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/streets/list/view/" + item_id,
        },
        {
          text: "Delete",
          disabled: true,
          href:"/admin/locations/streets/list/view/"+item_id+"/delete" 
        }
      ],
      navbar_cols: 3
    });
    this.load_item();
  },
};
</script>